var MobileHelper = /** @class */ (function () {
    function MobileHelper() {
    }
    MobileHelper.isMobileDevice = function () {
        return (new RegExp('Android|webOS|iPhone|iPad|' +
            'BlackBerry|Windows Phone|' +
            'Opera Mini|IEMobile|Mobile', 'i')).test(navigator.userAgent);
    };
    return MobileHelper;
}());
export { MobileHelper };
